import {useEffect, useState} from "react";

export const AVATAR_FADE_MS = 200;

const preloadImage = (src: string, onSuccess: () => void, onError: () => void): (() => void) => {
    const image = new Image();
    image.referrerPolicy = "no-referrer";
    image.onload = onSuccess;
    image.onerror = onError;
    image.src = src;

    if (image.complete && image.naturalWidth > 0) {
        onSuccess();
    }

    return () => {
        image.onload = null;
        image.onerror = null;
    };
};

const prefersReducedMotion = (): boolean => {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
};

export const useProfileAvatarReveal = (src?: string | null) => {
    const [isImageReady, setIsImageReady] = useState(false);
    const [keepIcon, setKeepIcon] = useState(true);
    const showImage = Boolean(src) && isImageReady;
    const showIcon = !showImage || keepIcon;

    useEffect(() => {
        setIsImageReady(false);
        setKeepIcon(true);

        if (!src) return;

        return preloadImage(
            src,
            () => setIsImageReady(true),
            () => setIsImageReady(false)
        );
    }, [src]);

    useEffect(() => {
        if (!showImage) {
            setKeepIcon(true);
            return;
        }

        if (prefersReducedMotion()) {
            setKeepIcon(false);
            return;
        }

        const timeoutId = window.setTimeout(() => setKeepIcon(false), AVATAR_FADE_MS);

        return () => window.clearTimeout(timeoutId);
    }, [showImage]);

    return {showIcon, showImage};
};
import {useEffect, useState} from "react";

export const AVATAR_FADE_MS = 200;

const preloadImage = (src: string, onSuccess: () => void, onError: () => void): (() => void) => {
    const image = new Image();
    image.referrerPolicy = "no-referrer";
    image.onload = onSuccess;
    image.onerror = onError;
    image.src = src;

    if (image.complete && image.naturalWidth > 0) {
        onSuccess();
    }

    return () => {
        image.onload = null;
        image.onerror = null;
    };
};

const prefersReducedMotion = (): boolean => {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
};

export const useProfileAvatarReveal = (src?: string | null) => {
    const [isImageReady, setIsImageReady] = useState(false);
    const [keepIcon, setKeepIcon] = useState(true);
    const showImage = Boolean(src) && isImageReady;
    const showIcon = !showImage || keepIcon;

    useEffect(() => {
        setIsImageReady(false);
        setKeepIcon(true);

        if (!src) return;

        return preloadImage(
            src,
            () => setIsImageReady(true),
            () => setIsImageReady(false)
        );
    }, [src]);

    useEffect(() => {
        if (!showImage) {
            setKeepIcon(true);
            return;
        }

        if (prefersReducedMotion()) {
            setKeepIcon(false);
            return;
        }

        const timeoutId = window.setTimeout(() => setKeepIcon(false), AVATAR_FADE_MS);

        return () => window.clearTimeout(timeoutId);
    }, [showImage]);

    return {showIcon, showImage};
};
